import JobFitCheckAPI from "../../../api/job-fit-checks/JobFitCheckAPI.js";

export const jfc = {
    namespaced: true,
    state() {
        return {
            previousJFCResults: [],
            activeJFCResult: null,
        }
    },
    getters: {
        previousJFCResults(state) {
            return state.previousJFCResults
        },
        activeJFCResult(state) {
            return state.activeJFCResult
        }
    },
    actions: {
        async fetchActiveJFCResult({ commit }, jfcId) {
            const response = await JobFitCheckAPI.getActiveJobFitCheck(jfcId);
            commit("setActiveJFCResult", response.data);
        },
        async fetchPreviousJFCResults({ commit }) {
            const response = await JobFitCheckAPI.getPreviousJobFitChecks();
            commit("setPreviousJFCResults", response.data);
        }
    },
    mutations: {
        setPreviousJFCResults(state, previousJFCResults) {
            state.previousJFCResults = previousJFCResults
        },
        updateJFCResults(state, newResult) {
            state.previousJFCResults = [
                newResult,
                ...state.previousJFCResults.filter(r => r.id !== newResult.id)
            ];
        },
        updateChecklistItemStatus(state, { projectShortId, gapIndex, done, deleted }) {
            const updateGaps = (items) => {
                return items.map(item => {
                    if (item.projectShortId === projectShortId) {
                        const currentGaps = item.gaps || [];
                        if (gapIndex < 0 || gapIndex >= currentGaps.length) return item;

                        const originalGap = currentGaps[gapIndex];
                        const updatedGap = {
                            ...originalGap,
                            ...(done !== undefined ? { done } : {}),
                            ...(deleted !== undefined ? { deleted } : {})
                        };

                        const updatedGaps = [...currentGaps];
                        updatedGaps[gapIndex] = updatedGap;

                        return {
                            ...item,
                            gaps: updatedGaps
                        };
                    }
                    return item;
                });
            };

            const breakdown = state.activeJFCResult?.portfolioBreakdown;
            if (!breakdown) return;

            state.activeJFCResult = {
                ...state.activeJFCResult,
                portfolioBreakdown: {
                    pages: updateGaps(breakdown.pages || []),
                    caseStudies: updateGaps(breakdown.caseStudies || [])
                }
            };
        },
        clearPreviousJFCResults(state) {
            state.previousJFCResults = []
        },
        setActiveJFCResult(state, activeJFCResult) {
            state.activeJFCResult = activeJFCResult
        },
        clearActiveJFCResult(state) {
            state.activeJFCResult = null
        }
    }
}